import * as Preact from "preact"

let UnitSprite = function() {}
import("@fae/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitExperienceBar from "@fae/source/views/components/UnitExperienceBar.jsx"

import "@fae/source/data/games/school/views/index.less"

export default function ProgressReport({stage, unit, message}) {
    if(unit == undefined) return
    if(unit.portraits == undefined) return // using this to cull unfinished snippets of units
    if(unit.affiliation != "good") return
    return (
        <div class="ProgressReport" element={unit.equippedItem?.element}>
            <div class="Thumbnail">
                <UnitSprite unit={unit}/>
            </div>
            <div class="Progress">
                <div class="LevelingDescription">
                    {unit.levelingCriteriaDescription}
                </div>
                <div class="Experience">
                    <UnitExperienceBar stage={stage} unit={unit}/>
                    <div class="Label">
                        {unit.experience} / {unit.maxexperience}
                    </div>
                </div>
                {message && <div class="Message">
                    <div class="Text">{message}</div>
                </div>}
            </div>
        </div>
    )
}
